import React from 'react';
import { animatedScrollTo } from '../../../helpers/scroll';
import { IFooterLink } from '../../../interfaces/IFooter';
import { FooterLink } from './FooterLink';

interface IProps {
    className?: string;
    list: IFooterLink[];
}

interface IState {
    expanded: boolean;
    countryCode: string;
}

// Transition duration for expand (height) and scroll to bottom
const transitionDuration = 400;

// Maximum section's height, has to be more than the heighest possible
const maxHeight = 200;

export class FooterBottom extends React.Component<IProps, IState> {
    state: IState = {
        expanded: false,
        countryCode: '',
    };

    componentDidMount() {
        this.setState({
            countryCode: (window as any).appState.pageData.appConfig.countryCode,
        });
    }

    componentDidUpdate(_, prevState) {
        if (this.state.expanded && !prevState.expanded) {
            this.scrollToBottom(maxHeight);
        }
    }

    handleToggle = () =>
        this.setState({
            expanded: !this.state.expanded,
        });

    handleClose = () =>
        this.setState({
            expanded: false,
        });

    scrollToBottom = (distance: number = 0) => {
        animatedScrollTo(
            document.body.offsetHeight - window.innerHeight + distance,
            transitionDuration,
        );
    };

    render() {
        return (
            <div className={this.props.className ? this.props.className : ''}>
                <div className="container">
                    <nav>
                        <ul className="list-inline">
                            {this.props.list.map((e, key) => (
                                <li key={key}>
                                    <FooterLink {...e} />
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}
